"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _react = _interopRequireWildcard(require("react"));
var _Search = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Search.svg"));
var _CancelOutline = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Cancel-outline.svg"));
var _Print = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Print.svg"));
var _Download = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Download.svg"));
var _businessFilter = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/business-filter.svg"));
var _addDropdown = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/add-Dropdown.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB ActionBar
 */

/**
  * SVBActionBar
  * see ../readme.MD for sample body
  * @param search: value of search
  * @param handleSearch: function to handle onchange for search input
  * @param filters: contains list of string values(Array of strings)
  * @param handleFilterSelect: function to handle on click of a new filter value from the dropdown
  * @param selectedFilter: value of the selected filter
  * @param handleBusinessFilter: function that returns on click of business filter icon
  * @param handleDownload: function that returns on click of download icon
  * @param handlePrint: function that returns on click of print icon
  * @param filterPlaceholder: placeholder text for dropdown filter
  * @param searchPlaceholder: placeholder text for search bar
  * @returns actionBar HTML with content
  */
const SVBActionBar = props => {
  const [focus, setFocus] = (0, _react.useState)(false);
  const search = props.search || "";
  const handleSearch = props.handleSearch;
  const filters = props.filters || [];
  const selectedFilter = props.selectedFilter || "";
  const handleFilterSelect = props.handleFilterSelect;
  const handleBusinessFilter = props.handleBusinessFilter;
  const handleDownload = props.handleDownload;
  const handlePrint = props.handlePrint;
  const searchPlaceholder = props.searchPlaceholder || "Search for keywords, values and more...";
  const filterPlaceholder = props.filterPlaceholder || "Select a Filter";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "action-bar-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "action-bar-search-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _Search.default
  }), /*#__PURE__*/_react.default.createElement("input", {
    onBlur: () => setFocus(false),
    value: search,
    onChange: event => handleSearch(event.target.value),
    onFocus: setFocus,
    type: "text",
    placeholder: searchPlaceholder,
    className: "action-bar-search"
  }), search !== "" && search && /*#__PURE__*/_react.default.createElement("img", {
    onClick: () => handleSearch(""),
    className: "action-item-cursor",
    src: _CancelOutline.default
  }), focus && /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => setFocus(!focus),
    type: "button",
    className: "svb-button svb-button_small svb-button_text-default svb-button_type-text action-bar-cancel-button-text-align"
  }, "Cancel"), /*#__PURE__*/_react.default.createElement("div", {
    className: "action-bar-icons-container"
  }, (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph medium action-bar-range-text"
  }, selectedFilter !== "" ? selectedFilter : filterPlaceholder), /*#__PURE__*/_react.default.createElement("img", {
    src: _addDropdown.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-content"
  }, filters === null || filters === void 0 ? void 0 : filters.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("a", {
      "data-testid": "filter-item",
      onClick: () => handleFilterSelect(item),
      key: index,
      className: "paragraph medium ".concat(item === selectedFilter && "selected-item"),
      href: "#"
    }, item);
  }))), /*#__PURE__*/_react.default.createElement("img", {
    onClick: handleBusinessFilter,
    src: _businessFilter.default,
    className: "action-bar-icons"
  }), /*#__PURE__*/_react.default.createElement("img", {
    onClick: handleDownload,
    src: _Download.default,
    className: "action-bar-icons"
  }), /*#__PURE__*/_react.default.createElement("img", {
    onClick: handlePrint,
    src: _Print.default,
    className: "action-bar-icons"
  }))));
};
var _default = SVBActionBar;
exports.default = _default;